const postOnboardingReturnToKey = 'mira.web.postOnboardingReturnTo';

export function safeReturnPath(value: string | null | undefined): string | null {
  if (!value || !value.startsWith('/')) return null;
  if (value.startsWith('//')) return null;
  if (value.startsWith('/auth') || value.startsWith('/register')) return null;
  return value;
}

export function storePostOnboardingReturnTo(value: string | null | undefined): void {
  const safe = safeReturnPath(value);
  if (safe) window.localStorage.setItem(postOnboardingReturnToKey, safe);
}

export function consumePostOnboardingReturnTo(): string | null {
  const value = safeReturnPath(window.localStorage.getItem(postOnboardingReturnToKey));
  window.localStorage.removeItem(postOnboardingReturnToKey);
  return value;
}

export function navigateHashPath(path: string): void {
  window.location.hash = path;
}
